











import QuizChoiceForm from '@/web/components/quizzes/QuizChoiceForm.vue';
import Vue from 'vue';

export default Vue.extend({
  components: {
    QuizChoiceForm,
  },
  props: {
    data: {
      type: Object as () => QuizQuestionResponse,
      required: true,
    },
    showManualCheck: {
      type: Boolean,
      required: true,
    },
  },
});
